(() => {
  const carouselSelector = 'swiper-container[data-related-products-carousel]';
  const navigationStyles = `
    .swiper-button-next, .swiper-button-prev {
      color: transparent;
      background-repeat: no-repeat;
      background-position: center;
      width: 24px;
      height: 24px;
      transition: background-color 0.3s;
    }
    .swiper-button-prev {
      left: 0; /* sits in the gap between the carousel edge and the first card */
      background-image: url("https://cdn.shopify.com/s/files/1/0510/4353/files/ArrowLeft.png?v=1725365791");
    }
    .swiper-button-next {
      right: 8px;
      background-image: url("https://cdn.shopify.com/s/files/1/0510/4353/files/ArrowRight.png?v=1725365418");
    }
    .swiper-button-next:hover, .swiper-button-prev:hover {
      background-color: #fff;
    }
    .swiper { padding-bottom: 30px; }
    .swiper-pagination { text-align: center; }
    .swiper-pagination-bullet, .swiper-pagination-bullet:empty {
      width: 8px;
      height: 8px;
      opacity: 1;
      background: #3333334d;
    }
    .swiper-pagination-bullet-active, .swiper-pagination-bullet-active:empty {
      background: #333;
    }
    .swiper-horizontal > .swiper-pagination-bullets,
    .swiper-pagination-bullets.swiper-pagination-horizontal {
      bottom: 0;
      text-align: center;
    }
    @media (max-width: 1023px) {
      .swiper-button-next, .swiper-button-prev {
        width: 16px;
        height: 16px;
      }
      .swiper-button-prev { left: 2px; }
    }
    @media (max-width: 767px) {
      .swiper-button-next, .swiper-button-prev { display: none; }
    }
  `;

  const initializeCarousel = (carousel) => {
    if (carousel.dataset.relatedProductsInitialized === 'true') return;

    const initialize = () => {
      if (carousel.dataset.relatedProductsInitialized === 'true' || typeof carousel.initialize !== 'function') return;

      const slideCount = carousel.querySelectorAll('swiper-slide').length;
      carousel.dataset.relatedProductsInitialized = 'true';

      Object.assign(carousel, {
        injectStyles: [navigationStyles],
        navigation: slideCount > 1,
        pagination: slideCount > 2,
        loop: slideCount > 5,
        // Keep in sync with sections/featured-collection-new.liquid (shared slide CSS).
        slidesPerView: 2.1,
        freeMode: {
          enabled: true,
          sticky: true,
        },
        breakpoints: {
          768: { pagination: false, slidesPerView: 3.5 },
          1024: { pagination: false, slidesPerView: 4.5 },
        },
      });

      carousel.initialize();
    };

    if (customElements.get('swiper-container')) {
      initialize();
    } else {
      customElements.whenDefined('swiper-container').then(initialize);
    }
  };

  const initializeCarousels = (root = document) => {
    if (root.matches?.(carouselSelector)) initializeCarousel(root);
    root.querySelectorAll?.(carouselSelector).forEach(initializeCarousel);
  };

  initializeCarousels();

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) initializeCarousels(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', (event) => initializeCarousels(event.target));
})();
